module.exports = __webpack_public_path__ + "static/img/6_3.e78f35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/6_3.png
// module id = Mo/v
// module chunks = 0